import { AutogenModelFieldInfo, AutogenRowFieldInfo } from "./autogen/AutogenModelFieldInfo";

export class ModelFieldInfo extends AutogenModelFieldInfo<RowFieldInfo> {
	constructor() {
		super(RowFieldInfo);
	}
}

export class RowFieldInfo extends AutogenRowFieldInfo {
}